import { z } from 'zod';

/**
 * Supported package ecosystems, in deps.dev `{system}` casing (ALL CAPS).
 * deps.dev is the primary provider, so its casing is canonical throughout the
 * app; OSV.dev uses different names, translated via the maps below.
 */
export const ecosystemSchema = z.enum(['NPM', 'PYPI', 'GO', 'MAVEN', 'CARGO', 'NUGET', 'RUBYGEMS']);
export type Ecosystem = z.infer<typeof ecosystemSchema>;

export const ECOSYSTEMS = ecosystemSchema.options;

/** deps.dev system → OSV `ecosystem` string (note `CARGO` ↔ `crates.io`). */
export const ECOSYSTEM_TO_OSV: Record<Ecosystem, string> = {
  NPM: 'npm',
  PYPI: 'PyPI',
  GO: 'Go',
  MAVEN: 'Maven',
  CARGO: 'crates.io',
  NUGET: 'NuGet',
  RUBYGEMS: 'RubyGems',
};

/** OSV `ecosystem` string → deps.dev system, for the subset we support. */
export const OSV_TO_ECOSYSTEM: Record<string, Ecosystem> = Object.fromEntries(
  Object.entries(ECOSYSTEM_TO_OSV).map(([system, osv]) => [osv, system as Ecosystem]),
);

/** Human-facing labels for the ecosystem selector. */
export const ECOSYSTEM_LABELS: Record<Ecosystem, string> = {
  NPM: 'npm',
  PYPI: 'PyPI',
  GO: 'Go',
  MAVEN: 'Maven',
  CARGO: 'Cargo (crates.io)',
  NUGET: 'NuGet',
  RUBYGEMS: 'RubyGems',
};
